import React, { Fragment, useState, useEffect } from "react";
import { TabContent, TabPane } from "reactstrap";
import * as Yup from "yup";
import UploadDocuments from "./UploadDocuments";
import classnames from "classnames";
import { Field, Form, FormikProvider, useFormik } from "formik";
import { useHistory } from "react-router-dom";
import Permissions from "./Permissions";
import moment from "moment";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { departmentList } from "../common/DepartmentsList";

const initialValues = {
  full_name: {
    first_name: "",
    middle_name: "",
    last_name: "",
    salutation: "--"
  },
  faculty_id: "",
  father_name: "",
  mother_name: "",
  spouse_name: "",
  date_of_birth: "",
  email_id: "",
  password: "",
  residential_address: "",
  department: "---",
  aadhar_number: "",
  pan_number: "",
  date_of_joining: "",
  date_of_retirement: "",
  relation_between_2_employee: "",
  phd_details: {
    year_of_phd: "",
    college_of_phd: "",
    phd_certificate: "",
  },
  no_of_phd_guided: {
    as_main_supervisor: "",
    as_co_supervisor: "",
  },
  no_of_papers_published: {
    national: 0,
    international: 0,
  },
  mobile_number: "",
  gender: "Male",
  subject_specialization: "",
  net_slet_details: {
    qualification_status: "No",
    year_of_passing: "",
    net_slet_id: "",
  },
  number_of_books_published: 0,
  awards_and_recognition: [""],
  patents_published_or_awarded: [""],
  fellowships_in_societies: [""],
  fellowships_awarded: [""],
  is_technical: "Teaching",
  reference_faculty: "",
  profile_photo_url: "",
  phd_documents: [],
  other_documents: []
};

const phoneRegExp = /[6789]{1}[0-9]{9}$/;

const uploadOptions = [
  {
    id: "profilePhoto",
    value: "Profile Photo",
    isMultiple: false,
    field: "profile_photo_url",
  },
  {
    id: "phd",
    value: "PhD Document",
    isMultiple: true,
    field: "phd_documents",
  },
  {
    id: "other",
    value: "Other Bulk Uploads",
    isMultiple: true,
    field: "other_documents",
  },
];

const ProfileForm = (props = {}) => {
  const {
    activeTab,
    isStaffLogin = false,
    createUser,
    updateUserProfile,
    dispatchVerifyActions,
    userProfile = {},
    creatingUser,
    updatingFaculty,
    verifyUser,
    verificationSuccess,
    isVerifyingUser,
    verifyApiCalled,
    permissions = {},
    isSuperAdmin,
  } = props;
  const history = useHistory();
  const [acceptedFiles, setAcceptedFiles] = useState([]);
  const [rejectedFiles, setRejectedFiles] = useState([]);
  const [uploadType, setUploadType] = useState("select");
  const newValues = { ...initialValues };

  useEffect(() => {
    if (isStaffLogin) {
      const {
        date_of_joining,
        date_of_retirement,
        date_of_birth,
        is_technical,
      } = userProfile;
      const technical = is_technical ? "Teaching" : "Non Teaching";
      formik.setValues(userProfile);
      formik.setFieldValue(
        "date_of_joining",
        moment(date_of_joining).format("YYYY-MM-DD")
      );
      formik.setFieldValue(
        "date_of_retirement",
        moment(date_of_retirement).format("YYYY-MM-DD")
      );
      formik.setFieldValue(
        "date_of_birth",
        moment(date_of_birth).format("YYYY-MM-DD")
      );
      formik.setFieldValue("is_technical", technical);
    }
    if (dispatchVerifyActions) {
      dispatchVerifyActions();
    }
  }, []);

  const validateSchema = Yup.object().shape({
    father_name: Yup.string(),
    mobile_number: Yup.string().required("Phone number is required"),
    faculty_id: Yup.string().required("College Id is required"),
    full_name: Yup.object().shape({
      first_name: Yup.string().required("First name is required"),
      salutation: Yup.string().not(["--"]).required('Salutation is required')
    }),
    is_technical: Yup.string().required("Faculty type is required"),
    email_id: Yup.string().required("Email Id is required"),
    department: Yup.string().not(["---"]).required("Department is mandatory"),
    reference_faculty: Yup.string().required("Reporting manager is mandatory")
  });

  const formik = useFormik({
    initialValues: isStaffLogin ? newValues : initialValues,
    validationSchema: validateSchema,
    onSubmit: () => handleFormSubmit(),
  });

  const handleFormSubmit = () => {
    const payload = { ...values };
    payload._id = userProfile._id;
    if (payload.is_technical === "Teaching") {
      payload.is_technical = true;
    } else {
      payload.is_technical = false;
    }
    delete payload.password;

    const callback = (message, type) =>
      toast(message, {
        position: "top-right",
        autoClose: 3000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: false,
        progress: undefined,
        type: type,
      });

    updateUserProfile(payload, callback);
  };

  const { values = {}, errors = {}, touched = {} } = formik;

  useEffect(() => {
    if (dispatchVerifyActions) {
      dispatchVerifyActions();
    }
  }, [values.reference_faculty]);

  const renderPersonalInfoSection = () => {
    let customClass = "";
    if (verifyApiCalled) {
      if (verificationSuccess) {
        customClass = "success";
      } else {
        customClass = "failed";
      }
    }
    return (
      <Fragment>
        <div className="col-md-2 col-sm-12">
          <div className="form-check">
            <Field
              name="is_technical"
              className="form-check-input"
              type="radio"
              value="Teaching"
              disabled={isStaffLogin}
            />
            <label>Teaching Staff</label>
          </div>
        </div>
        <div className="col-md-6 col-sm-12">
          <div className="form-check">
            <Field
              name="is_technical"
              className="form-check-input"
              type="radio"
              value="Non Teaching"
              disabled={isStaffLogin}
            />
            <label>Non-Teaching Staff</label>
          </div>
        </div>
        <div className="col-md-6 col-sm-12">
          <div className="form-group">
            <label>College Id </label>
            <span style={{ color: "red" }}>*</span>
            <Field
              name="faculty_id"
              className={`form-control ${touched.faculty_id && errors.faculty_id ? 'error' : ''}`}
              placeholder="DEPT-xxxx"
              type="text"
              value={values.faculty_id}
              disabled={isStaffLogin}
            />
          </div>
        </div>
        <div className="col-md-6 col-sm-12">
          <div className="form-group">
            <label>Phone </label>
            <span style={{ color: "red" }}>*</span>
            <div className="input-group">
              <div className="input-group-prepend">
                <div className="input-group-text">+91</div>
              </div>
              <Field
                name="mobile_number"
                className={`form-control ${touched.mobile_number && errors.mobile_number ? 'error' : ''}`}
                placeholder="99999 99999"
                type="text"
                maxLength="10"
                value={values.mobile_number}
                disabled={isStaffLogin}
              />
            </div>
            {values.mobile_number && errors?.mobile_number && !isStaffLogin && (
              <div className="danger" style={{ color: "red" }}>
                Invalid Pattern
              </div>
            )}
          </div>
        </div>

        <div className="col-md-1 col-sm-12">
          <div className="form-group">
            <label>Salutation</label>
            <span style={{ color: "red" }}>*</span>
            <Field
              as="select"
              name="full_name.salutation"
              className={`form-control ${touched?.full_name?.salutation && errors?.full_name?.salutation ? 'error' : ''}`}
              value={values.full_name.salutation}
            >
              <option value="--">--</option>
              <option value="Mr">Mr</option>
              <option value="Mrs">Mrs</option>
              <option value="Ms">Ms</option>
            </Field>
          </div>
        </div>

        <div className="col-md-4 col-sm-12">
          <div className="form-group">
            <label>First Name</label>
            <span style={{ color: "red" }}>*</span>
            <Field
              name="full_name.first_name"
              className={`form-control ${touched?.full_name?.first_name && errors?.full_name?.first_name ? 'error' : ''}`}
              placeholder="First Name"
              type="text"
              value={values.full_name.first_name}
            />
          </div>
        </div>

        <div className="col-md-3 col-sm-12">
          <div className="form-group">
            <label>Middle Name</label>
            <Field
              name="full_name.middle_name"
              className="form-control"
              placeholder="Middle Name"
              type="text"
              value={values.full_name.middle_name}
            />
          </div>
        </div>

        <div className="col-md-4 col-sm-12">
          <div className="form-group">
            <label>Last Name</label>
            <Field
              name="full_name.last_name"
              className="form-control"
              placeholder="Last Name"
              type="text"
              value={values.full_name.last_name}
            />
          </div>
        </div>

        <div className="col-md-4 col-sm-12">
          <div className="form-group">
            <label>Email Id</label>
            <span style={{ color: "red" }}>*</span>
            <Field
              name="email_id"
              className={`form-control ${touched.email_id && errors.email_id ? 'error' : ''}`}
              placeholder="johndoe@example.com"
              type="text"
              value={values.email_id}
              disabled={isStaffLogin}
            />
            {!isStaffLogin ? (
              <Fragment>
                <label className="mt-2">Password</label>
                <Field
                  name="password"
                  className="form-control"
                  type="password"
                  value={values.password}
                />
              </Fragment>
            ) :
              (
                <Fragment>
                  <label className="mt-2">Spouse Name</label>
                  <Field
                    name="spouse_name"
                    className="form-control"
                    placeholder="Spouse"
                    type="text"
                    value={values.spouse_name}
                  />
                </Fragment>
              )}
          </div>
        </div>

        <div className="col-md-4 col-sm-12">
          <div className="form-group">
            <label>Date of Birth</label>
            <Field
              name="date_of_birth"
              className="form-control"
              placeholder="Date of Birth"
              type="date"
              value={values.date_of_birth}
            />
            <label className="mt-2">Department</label>
            <span style={{ color: "red" }}>*</span>
            <Field
              as="select"
              name="department"
              className={`form-control ${touched.department && errors.department ? 'error' : ''}`}
              value={values.department}
            >
              <option value="---">---</option>

              {departmentList.map((val, index) => {
                return (
                  <option key={`${val}_${index}`} value={val}>
                    {val}
                  </option>
                );
              })}
            </Field>
          </div>
        </div>
        <div className="col-md-4 col-sm-12">
          <div className="form-group">
            <label>Father's Name</label>
            <Field
              name="father_name"
              className="form-control"
              placeholder="Father's Name"
              type="text"
              value={values.father_name}
            />
            <label className="mt-2">Mother's Name</label>
            <Field
              name="mother_name"
              className="form-control"
              placeholder="Mother's Name"
              type="text"
              value={values.mother_name}
            />
          </div>
        </div>

        {!isStaffLogin && (
          <div className="col-md-4 col-sm-12">
            <div className="form-group">
              <label>Spouse Name</label>
              <Field
                name="spouse_name"
                className="form-control"
                placeholder="Spouse"
                type="text"
                value={values.spouse_name}
              />
            </div>
          </div>
        )}
        <div className="col-sm-12">
          <div className="form-group">
            <label>Residential Address</label>
            <Field
              name="residential_address"
              className="form-control"
              placeholder="Address"
              type="text"
              value={values.residential_address}
            />
          </div>
        </div>

        <div className="col-md-2 col-sm-12">
          <div className="form-group">
            <label>Gender</label>
            <Field
              as="select"
              name="gender"
              className="form-control"
              value={values.gender}
            >
              <option value="Male">Male</option>
              <option value="Female">Female</option>
              <option value="Others">Other</option>
            </Field>
          </div>
        </div>
        <div className="col-md-4 col-sm-12">
          <div className="form-group">
            <label>PAN</label>
            <Field
              name="pan_number"
              className="form-control"
              placeholder="PAN"
              type="text"
              value={values.pan_number}
            />
          </div>
        </div>
        <div className="col-md-4 col-sm-12">
          <div className="form-group">
            <label>Aadhaar Number</label>
            <Field
              name="aadhaar_number"
              className="form-control"
              placeholder="xxxx-xxxx-xxxx"
              type="text"
              maxLength="12"
              value={values.aadhar_number}
            />
          </div>
        </div>
        <div className="col-md-4 col-sm-12">
          <div className="form-group">
            <label>Reporting Manager</label>
            <span style={{ color: "red" }}>*</span>
            <Field
              name="reference_faculty"
              className={`form-control ${customClass}`}
              placeholder="Enter Manager Id"
              type="text"
              value={values.reference_faculty}
              disabled={isStaffLogin}
            />
          </div>
        </div>
        {!isStaffLogin && (
          <div className=" form-inline mt-2 col-md-4 col-sm-12">
            <label></label>
            <button
              className="btn btn-outline-secondary"
              style={{ display: "block", marginTop: "0.4rem" }}
              disabled={!values.reference_faculty}
              onClick={() => verifyUser(values.reference_faculty)}
            >
              Verify
            </button>
            {isVerifyingUser && (
              <i className="fa fa-circle-o-notch fa-spin fa-fw ml-4"></i>
            )}
            <span className={`verify-status ${customClass} mt-2 ml-4`}>
              {customClass}
            </span>
          </div>
        )}
      </Fragment>
    );
  };

  const renderProfessionalInfoSection = () => {
    return (
      <Fragment>
        <div className="card-header add">
          <h3 className="card-title">Professional Information</h3>
        </div>

        <div className="col-md-3 col-sm-12">
          <div className="form-group">
            <label>{`Date of Joining (As in service register)`}</label>
            <Field
              name="date_of_joining"
              className="form-control"
              placeholder=""
              type="date"
              value={values.date_of_joining}
              disabled={isStaffLogin}
            />
          </div>
        </div>

        <div className="col-md-3 col-sm-12">
          <div className="form-group">
            <label>Date of Retirement</label>
            <Field
              name="date_of_retirement"
              className="form-control"
              placeholder=""
              type="date"
              value={values.date_of_retirement}
              disabled={isStaffLogin}
            />
          </div>
        </div>

        <div className="col-md-3 col-sm-12">
          <div className="form-group">
            <label>College Experience</label>
            <Field
              name="relation_between_2_employee"
              className="form-control"
              placeholder="(Years)"
              type="text"
              value={values.relation_between_2_employee}
            />
          </div>
        </div>

        <div className="col-md-4 col-sm-12">
          <div className="form-group">
            <label>NET/SLET Qualified</label>
            <Field
              as="select"
              name="net_slet_details.qualification_status"
              className="form-control"
              value={values.net_slet_details.qualification_status}
            >
              <option value="Yes">Yes</option>
              <option value="No">No</option>
            </Field>
          </div>
        </div>
        <div className="col-md-4 col-sm-12">
          <div className="form-group">
            <label>NET ID No.</label>
            <Field
              name="net_slet_details.net_slet_id"
              className="form-control"
              placeholder=""
              type="text"
              value={values.net_slet_details.net_slet_id}
              disabled={values.net_slet_details.qualification_status === "No"}
            />
          </div>
        </div>
        <div className="col-md-4 col-sm-12">
          <div className="form-group">
            <label>NET/SLET Passing Year</label>
            <Field
              name="net_slet_details.year_of_passing"
              className="form-control"
              placeholder=""
              type="text"
              value={values.net_slet_details.year_of_passing}
            />
          </div>
        </div>
        <div className="col-md-2 col-sm-12">
          <div className="form-group">
            <label>Year of PhD</label>
            <Field
              name="phd_details.year_of_phd"
              className="form-control"
              placeholder=""
              type="text"
              value={values.phd_details.year_of_phd}
            />
          </div>
        </div>
        <div className="col-md-6 col-sm-12">
          <div className="form-group">
            <label>University Name</label>
            <Field
              name="phd_details.college_of_phd"
              className="form-control"
              placeholder=""
              type="text"
              value={values.phd_details.college_of_phd}
            />
          </div>
        </div>
        <div className="col-md-4 col-sm-12">
          <div className="form-group">
            <label>Subject of Specialization</label>
            <Field
              name="subject_specialization"
              className="form-control"
              placeholder=""
              type="text"
              value={values.subject_specialization}
            />
          </div>
        </div>
        <div className="col-md-3 col-sm-12">
          <div className="form-group">
            <label>PhDs Guided as main supervisor</label>
            <Field
              name="no_of_phd_guided.as_main_supervisor"
              className="form-control"
              placeholder="0"
              type="text"
              value={values.no_of_phd_guided.as_main_supervisor}
            />
          </div>
        </div>
        <div className="col-md-3 col-sm-12">
          <div className="form-group">
            <label>PhDs Guided as co-supervisor</label>
            <Field
              name="no_of_phd_guided.as_co_supervisor"
              className="form-control"
              placeholder="0"
              type="text"
              value={values.no_of_phd_guided.as_co_supervisor}
            />
          </div>
        </div>
        <div className="col-md-3 col-sm-12">
          <label>Number of Papers Published</label>
          <div className="form-group" style={{ display: "flex" }}>
            <Field
              name="no_of_papers_published.national"
              className="form-control mr-sm-2"
              placeholder="National"
              type="text"
              value={values.no_of_papers_published.national}
            />
            <Field
              name="no_of_papers_published.international"
              className="form-control"
              placeholder="International"
              type="text"
              value={values.no_of_papers_published.international}
            />
          </div>
        </div>
        <div className="col-md-3 col-sm-12">
          <div className="form-group">
            <label>Number of Books Published</label>
            <Field
              name="number_of_books_published"
              className="form-control"
              placeholder={0}
              type="text"
              value={values.number_of_books_published}
            />
          </div>
        </div>
        <div className="col-md-6 col-sm-12">
          <label>{`Awards & Recognitions`}</label>
          <div
            className="form-group"
            style={{ display: "flex", alignItems: "center" }}
          >
            <div
              style={{
                display: "flex",
                flexDirection: "column",
                width: "100%",
              }}
            >
              {values?.awards_and_recognition?.map(({ award }, index) => {
                return (
                  <div
                    style={{
                      display: "flex",
                      flexDirection: "row",
                      alignItems: "center",
                      marginBottom: "0.6rem",
                    }}
                    key={index}
                  >
                    <div style={{ marginRight: "1rem" }}>{index + 1}.</div>
                    <Field
                      name={`awards_and_recognition[${index}]`}
                      className="form-control award"
                      placeholder=""
                      type="text"
                      style={{ marginRight: "1rem" }}
                    />
                    <div style={{ display: "grid" }}>
                      {values.awards_and_recognition.length === index + 1 && (
                        <>
                          <i
                            className="fa fa-plus plus-icon"
                            aria-hidden="true"
                            onClick={() =>
                              values.awards_and_recognition.push("")
                            }
                          ></i>
                        </>
                      )}
                      {values.awards_and_recognition.length === index + 1 &&
                        values.awards_and_recognition.length !== 1 && (
                          <>
                            <i
                              className="fa fa-minus minus-icon"
                              aria-hidden="true"
                              onClick={() =>
                                values.awards_and_recognition.pop()
                              }
                            ></i>
                          </>
                        )}
                    </div>
                  </div>
                );
              })}
            </div>
          </div>
        </div>
        <div className="col-md-6 col-sm-12">
          <label>Patents Published/Awarded</label>
          <div
            className="form-group"
            style={{ display: "flex", alignItems: "center" }}
          >
            <div
              style={{
                display: "flex",
                flexDirection: "column",
                width: "100%",
              }}
            >
              {values?.patents_published_or_awarded?.map(
                ({ patent }, index) => {
                  return (
                    <div
                      style={{
                        display: "flex",
                        flexDirection: "row",
                        alignItems: "center",
                        marginBottom: "0.6rem",
                      }}
                      key={index}
                    >
                      <div style={{ marginRight: "1rem" }}>{index + 1}.</div>
                      <Field
                        name={`patents_published_or_awarded[${index}]`}
                        className="form-control award"
                        placeholder=""
                        type="text"
                        style={{ marginRight: "1rem" }}
                      />
                      <div style={{ display: "grid" }}>
                        {values.patents_published_or_awarded.length ===
                          index + 1 && (
                            <i
                              className="fa fa-plus plus-icon"
                              aria-hidden="true"
                              onClick={() =>
                                values.patents_published_or_awarded.push("")
                              }
                            ></i>
                          )}
                        {values.patents_published_or_awarded.length ===
                          index + 1 &&
                          values.patents_published_or_awarded.length !== 1 && (
                            <>
                              <i
                                className="fa fa-minus minus-icon"
                                aria-hidden="true"
                                onClick={() =>
                                  values.patents_published_or_awarded.pop()
                                }
                              ></i>
                            </>
                          )}
                      </div>
                    </div>
                  );
                }
              )}
            </div>
          </div>
        </div>
        <div className="col-sm-12">
          <div className="form-group">
            <label>Fellowships in Societies</label>
            <div
              className="form-group"
              style={{ display: "flex", alignItems: "center" }}
            >
              <div
                style={{
                  display: "flex",
                  flexDirection: "column",
                  width: "100%",
                }}
              >
                {values?.fellowships_in_societies?.map(({ patent }, index) => {
                  return (
                    <div
                      style={{
                        display: "flex",
                        flexDirection: "row",
                        alignItems: "center",
                        marginBottom: "0.6rem",
                      }}
                      key={index}
                    >
                      <div style={{ marginRight: "1rem" }}>{index + 1}.</div>
                      <Field
                        name={`fellowships_in_societies[${index}]`}
                        className="form-control"
                        placeholder=""
                        type="text"
                        style={{ marginRight: "1rem" }}
                      />
                      <div style={{ display: "grid" }}>
                        {values.fellowships_in_societies.length ===
                          index + 1 && (
                            <i
                              className="fa fa-plus plus-icon"
                              aria-hidden="true"
                              onClick={() =>
                                values.fellowships_in_societies.push("")
                              }
                            ></i>
                          )}
                        {values.fellowships_in_societies.length === index + 1 &&
                          values.fellowships_in_societies.length !== 1 && (
                            <>
                              <i
                                className="fa fa-minus minus-icon"
                                aria-hidden="true"
                                onClick={() =>
                                  values.fellowships_in_societies.pop()
                                }
                              ></i>
                            </>
                          )}
                      </div>
                    </div>
                  );
                })}
              </div>
            </div>
          </div>
        </div>
        <div className="col-sm-12">
          <div className="form-group">
            <label>{`JRF/SRF/RA/YOUNG SCIENTIST Fellowships Awarded`}</label>
            <div
              className="form-group"
              style={{ display: "flex", alignItems: "center" }}
            >
              <div
                style={{
                  display: "flex",
                  flexDirection: "column",
                  width: "100%",
                }}
              >
                {values?.fellowships_awarded?.map(({ patent }, index) => {
                  return (
                    <div
                      style={{
                        display: "flex",
                        flexDirection: "row",
                        alignItems: "center",
                        marginBottom: "0.6rem",
                      }}
                      key={index}
                    >
                      <div style={{ marginRight: "1rem" }}>{index + 1}.</div>
                      <Field
                        name={`fellowships_awarded[${index}]`}
                        className="form-control"
                        placeholder=""
                        type="text"
                        style={{ marginRight: "1rem" }}
                      />
                      <div style={{ display: "grid" }}>
                        {values.fellowships_awarded.length === index + 1 && (
                          <i
                            className="fa fa-plus plus-icon"
                            aria-hidden="true"
                            onClick={() => values.fellowships_awarded.push("")}
                          ></i>
                        )}
                        {values.fellowships_awarded.length === index + 1 &&
                          values.fellowships_awarded.length !== 1 && (
                            <>
                              <i
                                className="fa fa-minus minus-icon"
                                aria-hidden="true"
                                onClick={() => values.fellowships_awarded.pop()}
                              ></i>
                            </>
                          )}
                      </div>
                    </div>
                  );
                })}
              </div>
            </div>
          </div>
        </div>
      </Fragment>
    );
  };

  const permissionSection = () => {
    if (isStaffLogin) {
      return null;
    }
    return (
      <Permissions
        submitForm={createUser}
        formFormik={formik}
        history={history}
        isFromAddUser
        isStaffLogin={isStaffLogin}
        creatingUser={creatingUser}
        verificationSuccess={verificationSuccess}
        dispatchVerifyActions={dispatchVerifyActions}
        permissions={permissions}
        isUserSuperAdmin={isSuperAdmin}
      />
    );
  };

  const onDrop = (acceptFiles = [], rejectFiles = []) => {
    const newAccepted = [...acceptedFiles, ...acceptFiles];
    const newRejected = [...rejectedFiles, ...rejectFiles];
    newAccepted.forEach((file, index) =>
      Object.assign(file, {
        preview: URL.createObjectURL(file),
        fileId: `file_${index}`,
      })
    );
    setAcceptedFiles(newAccepted);
    setRejectedFiles(newRejected);
  };

  const removeFile = (id) => {
    const newAccepted = acceptedFiles.filter((file) => file.fileId !== id);
    setAcceptedFiles(newAccepted);
  };

  const onChangeUploadType = (value) => {
    setUploadType(value);
  };

  const renderUploadSection = () => {
    const {
      profile_photo_url = "",
      other_documents = [],
      phd_documents = [],
    } = values;
    const docs = {
      profile_photo_url,
      other_documents,
      phd_documents,
    };
    return (
      <UploadDocuments
        uploadOptions={uploadOptions}
        removeFile={removeFile}
        onDrop={onDrop}
        onChangeUploadType={onChangeUploadType}
        uploadType={uploadType}
        rejectedFiles={rejectedFiles}
        acceptedFiles={acceptedFiles}
        setAcceptedFiles={setAcceptedFiles}
        userFacultyId={values.faculty_id}
        isStaffLogin={isStaffLogin}
        docs={docs}
      />
    );
  };

  const renderUploadedDocuments = () => {
    if (!isStaffLogin) return null;
    const {
      profile_photo_url = "",
      other_documents = [],
      phd_documents = [],
    } = values;

    return (
      <Fragment>
        <hr />
        <div className="card">
          <div className="card-header upload">
            <h3 className="card-title">User Uploaded Documents</h3>
          </div>
          <div className="pl-5 pb-3">
            {profile_photo_url && (
              <>
                <h6>Profile Photo</h6>
                <li>
                  <a
                    href={profile_photo_url}
                    rel="noopener noreferrer"
                    target="_blank"
                  >
                    Profile Photo
                  </a>
                </li>
              </>
            )}
            {phd_documents.length > 0 && (
              <h6 className="mt-3">PhD Documents</h6>
            )}
            {phd_documents.map((url, idx) => {
              return (
                <li key={idx}>
                  <a
                    href={url}
                    rel="noopener noreferrer"
                    target="_blank"
                  >{`Phd Document ${idx + 1}`}</a>
                </li>
              );
            })}
            {other_documents.length > 0 && (
              <h6 className="mt-3">Other Bulk Documents</h6>
            )}
            {other_documents.map((url, idx) => {
              return (
                <li key={idx}>
                  <a
                    href={url}
                    rel="noopener noreferrer"
                    target="_blank"
                  >{`Other Document ${idx + 1}`}</a>
                </li>
              );
            })}
          </div>
        </div>
      </Fragment>
    );
  };

  const renderForm = () => {
    return (
      <FormikProvider value={formik}>
        <Form onSubmit={formik.handleSubmit} style={{ display: "contents" }}>
          {renderPersonalInfoSection()}
          <hr className="section-hr" />
          {renderProfessionalInfoSection()}
          <hr className="section-hr" />
          {isStaffLogin && (
            <div className="col-sm-12 mt-2 mb-2">
              <button
                type="submit"
                className="mr-1 btn btn-primary"
                disabled={updatingFaculty}
              >
                {updatingFaculty ? (
                  <i className="fa fa-circle-o-notch fa-spin fa-fw"></i>
                ) : (
                  "Update"
                )}
              </button>
              <button
                className="btn btn-outline-secondary"
                onClick={() => {
                  formik.resetForm();
                  history.push("/");
                }}
                disabled={updatingFaculty}
              >
                Cancel
              </button>
            </div>
          )}
        </Form>
        {permissionSection()}
      </FormikProvider>
    );
  };

  return (
    <Fragment>
      <div className="section-body mt-4">
        <div className="container-fluid">
          <TabContent activeTab={activeTab}>
            <TabPane tabId={1} className={classnames(["fade show"])}>
              <div className="row clearfix">
                <div className="col-lg-12 col-md-12 col-sm-12">
                  <div className="card">
                    <div className="card-header">
                      <h3 className="card-title">Personal Information</h3>
                    </div>
                    <div className="card-body">
                      <div className="row clearfix">{renderForm()}</div>
                    </div>
                  </div>
                </div>
              </div>
            </TabPane>
          </TabContent>
          <TabContent activeTab={activeTab}>
            <TabPane tabId={2} className={classnames(["fade show"])}>
              <div className="row clearfix">
                <div className="col-lg-12 col-md-12 col-sm-12">
                  <div className="card">{renderUploadSection()}</div>
                  {renderUploadedDocuments()}
                </div>
              </div>
            </TabPane>
          </TabContent>
        </div>
      </div>
      <ToastContainer />
    </Fragment>
  );
};

export default ProfileForm;
